import axios from "axios";
import { server } from "../../server";

// Отримання всіх субкатегорій
export const getSubcategories = () => async (dispatch) => {
  try {
    dispatch({ type: "subcategoriesRequest" });
    const { data } = await axios.get(`${server}/subcategory/get-subcategories`);
    dispatch({ type: "subcategoriesSuccess", payload: data.subcategories });
  } catch (error) {
    dispatch({
      type: "subcategoriesFail",
      payload: error.response?.data?.message || "Failed to fetch subcategories",
    });
  }
};

// Створення субкатегорії
export const createSubcategory = (subcategoryData) => async (dispatch) => {
  try {
    dispatch({ type: "createSubcategoryRequest" });
    const { data } = await axios.post(
      `${server}/subcategory/create-subcategory`,
      subcategoryData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    dispatch({ type: "createSubcategorySuccess", payload: data.subcategory });
  } catch (error) {
    dispatch({
      type: "createSubcategoryFail",
      payload: error.response?.data?.message || "Failed to create subcategory",
    });
  }
};

// Оновлення субкатегорії
export const updateSubcategory = (id, subcategoryData) => async (dispatch) => {
  try {
    dispatch({ type: "updateSubcategoryRequest" });
    const { data } = await axios.put(
      `${server}/subcategory/update-subcategory/${id}`,
      subcategoryData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    dispatch({ type: "updateSubcategorySuccess", payload: data.subcategory });
  } catch (error) {
    dispatch({
      type: "updateSubcategoryFail",
      payload: error.response?.data?.message || "Failed to update subcategory",
    });
  }
};

// Видалення субкатегорії
export const deleteSubcategory = (id) => async (dispatch) => {
  try {
    dispatch({ type: "deleteSubcategoryRequest" });
    await axios.delete(`${server}/subcategory/delete-subcategory/${id}`);
    dispatch({ type: "deleteSubcategorySuccess", payload: id });
  } catch (error) {
    dispatch({
      type: "deleteSubcategoryFail",
      payload: error.response?.data?.message || "Failed to delete subcategory",
    });
  }
};

// Отримання товарів за субкатегорією
export const getSubcategoryProducts = (id) => async (dispatch) => {
  try {
    dispatch({ type: "getSubcategoryProductsRequest" });
    const { data } = await axios.get(`${server}/subcategory/get-subcategory-products/${id}`);
    dispatch({ type: "getSubcategoryProductsSuccess", payload: data.products });
  } catch (error) {
    dispatch({
      type: "getSubcategoryProductsFail",
      payload: error.response?.data?.message || "Failed to fetch products",
    });
  }
};